import { render } from "./UniversalViewer3.vue?vue&type=template&id=65d070f4&scoped=true"
import script from "./UniversalViewer3.vue?vue&type=script&lang=js"
export * from "./UniversalViewer3.vue?vue&type=script&lang=js"

import "./UniversalViewer3.vue?vue&type=style&index=0&id=65d070f4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dl-viewer/dl-viewer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d070f4"]])

export default __exports__